import React, { useState } from 'react';

const MessageInput = ({ onSend, disabled }) => {
  const [content, setContent] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!content.trim() || disabled) return;
    onSend(content);
    setContent('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-end gap-2 bg-transparent">
      <div className="flex-1 bg-gray-100/80 hover:bg-gray-100 transition-colors rounded-3xl flex items-end border border-transparent focus-within:border-gray-300 focus-within:bg-white shadow-inner px-4 py-1.5">
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          placeholder={disabled ? "Conversation resolved" : "Type a message..."}
          className="w-full bg-transparent border-none focus:ring-0 resize-none max-h-32 min-h-[44px] py-2.5 text-gray-800 placeholder-gray-400 text-[15px]"
          rows="1"
          style={{ height: 'auto' }}
          onInput={(e) => {
            e.target.style.height = 'auto';
            e.target.style.height = Math.min(e.target.scrollHeight, 128) + 'px';
          }}
        />
      </div>
      <button
        type="submit"
        disabled={disabled || !content.trim()}
        className={`w-12 h-12 flex-shrink-0 rounded-full flex items-center justify-center transition-all ${
          content.trim() && !disabled
            ? 'bg-green-500 hover:bg-green-600 text-white shadow-md active:scale-95'
            : 'bg-gray-200 text-gray-400 cursor-not-allowed'
        }`}
      >
        <svg className="w-5 h-5 ml-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
        </svg>
      </button>
    </form>
  );
};

export default MessageInput;
